import React from "react"

import { Card } from "react-bootstrap"

import OperatorOnly from "@/auth_descriptor/OperatorOnly"
import CruiseLineOnly from "@/auth_descriptor/CruiseLineOnly"
import Profile from "./Profile"

const ProfileCard = (props) => (
  <Card>
    <Card.Header className="d-inline-flex flex-column gap-4">
      <OperatorOnly>
        <h1 className="h4 mb-0">Application for {props.view.heading}</h1>
      </OperatorOnly>
      <CruiseLineOnly>
        <h1 className="h4 mb-0">{props.view.heading} Application</h1>
      </CruiseLineOnly>
    </Card.Header>
    <Card.Body>
      <Profile {...props} />
    </Card.Body>
  </Card>
)

export default ProfileCard
